<template>
    <div class="usermenu" ref="userMenuElement" />
</template>

<script setup lang="ts">
    import { UserMenu } from "@/app/ui/UserMenu";
    import { onMounted, ref } from "vue";

    const userMenuElement = ref<HTMLElement | null>(null);

    onMounted(() => {
        new UserMenu({
            element: $(userMenuElement.value!),
        });
    });
</script>
